module.exports = __webpack_public_path__ + "img/ScenicIndex.fdad7bcd.jpg";